<template>
<el-dialog title="修改密码" v-if="editPwdShow" :visible.sync="editPwdShow" @close="dataInit" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" width="600px" top="240px">
    <el-form label-width="90px" ref="Form" :rules="rules" :model="ruleForm">
        <el-form-item class="pwd-form-item" label="手机号" prop="mobile">
            <el-input :type="'text'" placeholder="请输入手机号" clearable v-model="ruleForm.mobile" maxlength="11" @focus="FocusInput" ref="inputFirst"></el-input>
        </el-form-item>
        <el-form-item class="pwd-form-item" label="验证码" prop="verifyCode">
            <el-input :type="'text'" placeholder="请输入验证码" clearable="clearable" v-model="ruleForm.verifyCode" @focus="FocusInput" style="width: 308px;margin-right: 10px;"> </el-input>
            <el-button type="primary" @click="getVerification('Form')" style="width:146px">{{verifystatus?"获取验证码":verifymsg+"S"}}</el-button>
        </el-form-item>
        <el-form-item class="pwd-form-item" label="新密码" prop="new_password">
            <el-input :type="'password'" placeholder="请输6-20位新密码，包含字母和数字" clearable="clearable" v-model="ruleForm.new_password" maxlength="20" @focus="FocusInput"></el-input>
        </el-form-item>
        <el-form-item class="pwd-form-item" label="确认新密码" prop="new_password_">
            <el-input :type="'password'" placeholder="请再次输入新密码" clearable="clearable" v-model="ruleForm.new_password_" maxlength="20" @focus="FocusInput"></el-input>
        </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer">
        <el-button class="btn90" type="primary" @click="submitForm('Form')">确定</el-button>
        <el-button class="btn90" @click="editPwdShow=!editPwdShow">取消</el-button>
    </div>
</el-dialog>

</template>
<script>
// import { BASE_URL ,USER_URL} from "@/config/IPconfig";
import Bus from "@/Bus.js"
// import { encrypt, decrypt } from '@/utils/jsencrypt'
// import { removeToken } from '@/utils/auth'
// import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

export default {
    name:'editPwd',
    data() {
        var checkPhone = (rule, value, callback) => {
		    const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/
		    if (!value) {
		        return callback(new Error('电话号码不能为空'))
		    }
		    setTimeout(() => {
		      
                if (!Number.isInteger(+value)) {
                    callback(new Error('请输入数字值'))
                } else {
                    if (phoneReg.test(value)) {
                    callback()
                    } else {
                    callback(new Error('电话号码格式不正确'))
                    }
                }
		    }, 100)
        };
        // var validatePass = (rule, value, callback) => {
        //     if (value === '') {
        //             callback(new Error('请输入密码'));
        //     } else {
        //         if (this.ruleForm.new_password !== '') {
        //             this.$refs.Form.validateField('new_password');
        //         }
        //         callback();
        //     }
        // };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (this.ruleForm.new_password!=value) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            USER_URL:window.$server_config.VUE_APP_USER_API,
            ruleForm:{
                mobile:'',
                verifyCode:'',
                new_password:'',
                new_password_:'',
            },
            verifystatus:true,
            verifymsg:60,
            timer:null,
            disabled:true,
            errorText:'',
            editPwdShow:false,
            eyeHideList:{new_password:true,new_password_:true},
            rules:{
                mobile:[
                    {required: true, validator: checkPhone, trigger: 'blur' }
                ],
                verifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                new_password:[
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    // { validator: validatePass, trigger: 'blur' }
                ],
                new_password_:[
                    // { required: true, message: '请输入确认新密码', trigger: 'blur' },
                    { required: true, validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    mounted() {
        Bus.$on('editPwdShow', (data)=>{
            this.editPwdShow=data
            if(data){
                this.$nextTick(() => {
                    if(typeof(this.$refs.inputFirst)!=='undefined'){
                        this.$refs.inputFirst.$el.querySelector('input').focus()
                    }
                })
            }
        })
    },
    beforeDestory(){
        Bus.$off('editPwdShow')
    },
    watch:{
        'editPwdShow'(nv,ov){
            if(nv==true&&ov==false){
                this.$nextTick(() => {
                    this.$refs.Form.clearValidate();
                })
            }
        },
    //    'ruleForm': {
    //         deep: true,
    //         immediate: true,
    //         handler: function (newVal,oldVal){
    //             var disabled=false
    //             for(var k in newVal){
    //                 if(newVal[k]==''){
    //                     disabled=true
    //                     break;
    //                 }else{
    //                     disabled=false
    //                 }
    //             }
    //             this.disabled=disabled
    //         }
    //     },
        // 'ruleForm.mobile'(nv,ov){
        //    const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/
		//     if (!value) {
		//         return callback(new Error('电话号码不能为空'))
		//     }
		//     setTimeout(() => {
        //         if (!Number.isInteger(+value)) {
        //             callback(new Error('请输入数字值'))
        //         } else {
        //             if (phoneReg.test(value)) {
        //                 this.verifystatus = false;
        //                 this.timeToRefresh()
        //                 this.sendMsg();
        //             } else {
        //             callback(new Error('电话号码格式不正确'))
        //             }
        //         }
        //     }, 100)
        // },
        // 'ruleForm.new_password'(nv,ov){
        //     var reg=/^[A-Za-z0-9`~!@#$%^&*()_+-=;':"\\|,./<>?]+$/
        //     if(this.ruleForm.new_password===''){
        //         return
        //     }
        //     if(reg.test(nv)){
        //         this.ruleForm.new_password=nv
        //     }else{
        //         if(reg.test(ov)){
        //             this.ruleForm.new_password=ov
        //         }else{
        //             this.ruleForm.new_password=''
        //         }
        //     }
            
        // },
        // 'ruleForm.new_password_'(nv,ov){
        //     var reg=/^[A-Za-z0-9`~!@#$%^&*()_+-=;':"\\|,./<>?]+$/
        //     if(this.ruleForm.new_password_===''){
        //         return
        //     }
        //     if(reg.test(nv)){
        //         this.ruleForm.new_password_=nv
        //     }else{
        //         if(reg.test(ov)){
        //             this.ruleForm.new_password_=ov
        //         }else{
        //             this.ruleForm.new_password_=''
        //         }
        //     }
        // }
    },
    methods:{
        pwdHideToggle(type){
            this.eyeHideList[type]=!this.eyeHideList[type]
            if(this.eyeHideList[type]){

            }else{
                //this.$refs.inputFirst.type = "password";
            }
        },
        dataInit(){
            Object.assign(this.$data, this.$options.data());
        },
        getVerification(Form){
            // const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/
		    // if (!value) {
		    //     return callback(new Error('电话号码不能为空'))
		    // }
		    // setTimeout(() => {
            //     if (!Number.isInteger(+value)) {
            //         callback(new Error('请输入数字值'))
            //     } else {
            //         if (phoneReg.test(value)) {
            //             this.verifystatus = false;
            //             this.timeToRefresh()
            //             this.sendMsg();
            //         } else {
            //         callback(new Error('电话号码格式不正确'))
            //         }
            //     }
            // }, 100)
            
            this.$refs[Form].validateField("mobile",valid => {
                if (valid==""&&this.verifystatus) {
                    this.verifystatus = false;
                    this.timeToRefresh()
                    this.sendMsg();
                } else {
                    // Message.error("请输入正确的手机号")
                    return false;
                }
            });
        },
        clearInterval(){
            clearInterval(this.timer)
            this.timer = null
        },
        timeToRefresh(){
            this.timer = setInterval(()=>{
                // 调用的方法
                this.verifymsg--
                if(this.verifymsg<=0){
                    this.verifystatus = true;
                    this.clearInterval();
                    this.verifymsg = 60;
                }
            },1000)
        },
        sendMsg(){
            this.errorPhone = ""
            axios.get(`${this.USER_URL}/api/messageEmail/sendMsg`,{params:{  
                    mobile:this.ruleForm.mobile           
                }},
                { 
                    // headers: {
                    //         "token":getToken()
                    //     }            
                }
            ).then((res)=>{
                var result=res.data
                if(res.data.code== 200&&JSON.parse(res.data.data).code== 200){
                    Message({
                        message: '验证码已发送，请注意查收',
                        type: 'success'
                    });
                }else{
                    this.errorPhone = JSON.parse(res.data.data).msg;
                }
            }).catch(res => {
                if (axios.isCancel(res)) {//终止请求

                } else {

                }
                Message.error(res.data.msg)
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    axios.get(`${this.USER_URL}/api/messageEmail/validateMessage`,{params:{  
                            mobile:this.ruleForm.mobile,
                            verifyCode : this.ruleForm.verifyCode           
                        }},
                        {             
                        }
                    ).then((res)=>{
                        var result=res.data.data
                        if(res.data.code== 200){
                            axios.post(`${this.USER_URL}/api/userTypeEntity/updateUserInfoPwdBySearchPwd`,{
                                    mobile:this.ruleForm.mobile,
                                    pwd:this.ruleForm.new_password,
                                }
                                ,{}
                            ).then((res)=>{
                                if(res.data.code== 200){
                                    Message({
                                        message: '修改密码成功',
                                        type: 'success'
                                    });
                                    this.editPwdShow = false;
                                }else{
                                    Message.error(res.data.msg)
                                }
                            }).catch(res => {
                                if (axios.isCancel(res)) {//终止请求
                                } else {
                                }
                                Message.error(res.data.msg)
                            })

                        }else{
                            this.errorPhone = res.data.msg;
                            Message.error(res.data.msg)
                        }
                    }).catch(res => {
                        if (axios.isCancel(res)) {//终止请求
                        } else {
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        FocusInput(){//用户输入时清空之前错误提示
            this.errorText=""
        },
        close(){//关闭编辑密码弹窗
            Bus.$emit('editPwdShow', false)
        },
        
    },
    
}
</script>
<style scoped lang="less">
    @deep: ~'>>>';
   .error-item{
        margin-top:-5px;
        line-height: 19px;
        .error-left{float: left;width:0;height:19px}
        .error-msg{
            margin-left:0;
            color: #E33030;
            font-size: 14px;
            text-align: center;
        }
    }
    .pwd-eye{
        position: absolute;
        top: 0;
        right: 34px;
        color: #a2a7ad;
    }
</style>

<style lang="less">
    .edit-pwd-dialog{
        .el-dialog__header{
            padding:20px 40px 10px;
            .el-dialog__title{font-size: 16px;line-height:16px;color:#11151A;}
            .el-dialog__headerbtn .el-dialog__close{color:#979797;top: 24px;}
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/editPwd/forget.vue